export interface ArticleTeaser {
  slug: string;
  title: string;
  category: string | null;
  image: string | null;
  readingTime: number | null;
  summary: string | null;
}

interface TeaserAttributes {
  slug?: string;
  title?: string;
  readingTime?: number;
  summary?: string | null;
  image?: { data?: { attributes?: { url?: string } } | null };
  categories?: { data?: Array<{ attributes?: { title?: string } }> };
  seo?: { metaDescription?: string | null } | null;
}

export const TEASER_FIELDS = ["slug", "title", "readingTime", "summary"];

export const TEASER_POPULATE = {
  image: { fields: ["url"] },
  categories: { fields: ["title"] },
  seo: { fields: ["metaDescription"] },
};

// Two in three articles have no summary, but every one has a meta description.
const summaryOf = (attributes: TeaserAttributes) =>
  attributes.summary?.trim() || attributes.seo?.metaDescription?.trim() || null;

export const toTeasers = (
  entries: Array<{ attributes?: unknown }>,
): ArticleTeaser[] =>
  entries.flatMap((entry) => {
    const attributes = entry.attributes as TeaserAttributes | undefined;

    return attributes?.slug && attributes.title
      ? [
          {
            slug: attributes.slug,
            title: attributes.title,
            category:
              attributes.categories?.data?.[0]?.attributes?.title ?? null,
            image: attributes.image?.data?.attributes?.url ?? null,
            readingTime: attributes.readingTime ?? null,
            summary: summaryOf(attributes),
          },
        ]
      : [];
  });
